import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import type { FacebookCampaign } from '@feathr/blackbox';
import { CardV2 as Card, Form, Input } from '@feathr/components';

import FacebookCampaignObjective from './FacebookCampaignObjective';

import * as styles from '../../AdWizard/AdWizard.css';

interface IProps {
  onNext: () => void;
  campaign: FacebookCampaign;
}

function FacebookGeneralStep({ campaign }: IProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <Form className={styles.formRoot} label={t('Edit Campaign: Name and objective')}>
      <Card>
        <Card.Header
          description={
            <Trans t={t}>
              <p>
                Provide a descriptive name for your campaign so you can find it later. It helps to
                put the targets and goals, if any, of the campaign in the name; E.g., "Cart
                Abandoners - Registration".
              </p>
              <p>
                <a
                  href={
                    'https://help.feathr.co/hc/en-us/articles/360048057553-How-to-launch-a-Facebook-campaign-from-Feathr'
                  }
                  target={'_blank'}
                >
                  Check out our help desk to learn about Meta Campaign best practices.
                </a>
              </p>
            </Trans>
          }
          title={t('General')}
        />
        <Card.Content addVerticalGap={true}>
          <Input
            attribute={'name'}
            label={t('Name')}
            model={campaign}
            name={'campaign_name'}
            required={true}
            type={'text'}
          />
          <FacebookCampaignObjective campaign={campaign} />
        </Card.Content>
      </Card>
    </Form>
  );
}

export default observer(FacebookGeneralStep);
